import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  CircularProgress,
} from "@mui/material";
import { CheckCircle, Error, LocationOn } from "@mui/icons-material";
import { digilockerService } from "../Services/DigilockerServices";
import { geolocationService } from "../Services/GeolocationService";
import { SessionStore } from "../Services/SessionStore";
import { useSelector } from "react-redux";

const DigiLockerCard = ({ onAuthorize }) => {
  const [open, setOpen] = useState(false);
  const [authUrl, setAuthUrl] = useState("");
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [step, setStep] = useState("input");
  const [accessToken, setAccessToken] = useState(null);
  const [callbackResult, setCallbackResult] = useState(null);
  // const [locationDialog, setLocationDialog] = useState(false);
  // const [locationCheck, setLocationCheck] = useState({
  //   loading: false,
  //   result: null,
  //   error: null,
  // });

  const customerSession = localStorage.getItem("session");
  const sessionId = localStorage.getItem("session_id");

  // ⚠️ (NO CHANGE IN LOGIC — only UI updates below)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state");

    if (code && state) {
      setOpen(true);
      setStep("processing");
      handleDigiLockerCallback(code, state);
    }else{
      window.history.replaceState({}, document.title, "/");
      handleClose();
    }
  }, []);

  const handleDigiLockerCallback = async (code, state) => {
    try {
      setStep("processing");
      const codeVerifier = localStorage.getItem("dl_code_verifier");

      if (!codeVerifier) throw new Error("Missing code_verifier");

      const tokenData = await digilockerService.getAccessToken(code, codeVerifier);

      if (tokenData.access_token) {
        setAccessToken(tokenData.access_token);
        localStorage.setItem("dl_access_token", tokenData.access_token);
        const prevPath = localStorage.getItem("dl_prev_path");
        window.history.replaceState({}, document.title, prevPath || "/");
        await handleCallbackCall(tokenData.access_token, state, sessionId, customerSession);
      } else throw new Error("No access token received");
    } catch (error) {
      setStep("digilocker");
    }
  };

  const handleCallbackCall = async (token, state, sessionId, customerSession) => {
    try {
      setStep("callback");

      
      const result = await digilockerService.handleCallback(token, state, sessionId, customerSession);
      if (sessionId) SessionStore.setSessionId(sessionId);
      setCallbackResult(result);
      setStep("complete");
    } catch {
      setStep("digilocker");
    }
  };

  const handleOpen = async () => {
    // setLocationDialog(true);
    // setLocationCheck({ loading: true, result: null, error: null });

    // try {
    //   const result = await geolocationService.checkUserLocation();
    //   setLocationCheck({ loading: false, result, error: null });

    //   if (result.is_indian) {
    //     setTimeout(() => {
    //       setLocationDialog(false);
          setOpen(true);
          setStep("input");
    //     }, 2000);
    //   }
    // } catch (error) {
    //   setLocationCheck({ loading: false, result: null, error: error.message });
    // }
  };

  const handleVerify = async (customerSession) => {
    try {
      const { auth_url, state, code_verifier } = await digilockerService.getAuthUrl(aadhaarNumber, customerSession);
      if (state) localStorage.setItem("dl_state", state);
      if (code_verifier) localStorage.setItem("dl_code_verifier", code_verifier);
      localStorage.setItem("dl_prev_path", window.location.pathname + window.location.search);
      setAuthUrl(auth_url);
      setStep("digilocker");
      if (auth_url) window.location.assign(auth_url);
    } catch {
      setAuthUrl("");
      setStep("digilocker");
    }
  };

  const handleClose = () => {
    setOpen(false);
    setAuthUrl("");
    setAadhaarNumber("");
    setStep("input");
    setAccessToken(null);
  };

  const handleAuthorize = () => {
    if (onAuthorize) onAuthorize();
    setOpen(false);
  };

  return (
    <>
      {/* 📌 Responsive Wrapper Around Card */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          minHeight: { xs: "55vh", sm: "60vh", md: "55vh" },
          px: { xs: 2, sm: 3 },
          mt: { xs: 1, sm: 2 },
          pb: { xs: 3, sm: 4 }, // 👌 better bottom spacing
        }}
      >
        <Card
          sx={{
            width: "100%",
            maxWidth: "600px",
            borderRadius: 3,
            boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
            p: { xs: 2, sm: 3 },
            overflow: "hidden",
          }}
        >
          <CardContent>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Start with DigiLocker
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={2}>
              We use DigiLocker to securely verify your Aadhaar.
            </Typography>

            <Button
              fullWidth
              variant="contained"
              sx={{
                mt: 2,
                py: 1.5,
                fontWeight: "bold",
                textTransform: "none",
                background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
                "&:hover": { background: "linear-gradient(45deg, #125ea2 30%, #1976d2 90%)" },
                borderRadius: 2,
                boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
              }}
              onClick={() => handleOpen()}
              startIcon={<LocationOn />}
            >
              Start KYC Process
            </Button>

            <Box mt={2}>
              <Typography variant="caption" color="text.secondary">
                Your documents are encrypted and used only for verification.
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>

      {/* Location Verification Dialog */}
      {/* <Dialog 
        open={locationDialog} 
        onClose={() => setLocationDialog(false)} 
        maxWidth="sm" 
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
          }
        }}
      >
        <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
          <LocationOn sx={{ fontSize: 40, mb: 1 }} />
          <Typography variant="h6">Location Verification</Typography>
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center", py: 3 }}>
          {locationCheck.loading && (
            <Box>
              <CircularProgress sx={{ color: "white", mb: 2 }} />
              <Typography>Verifying your location...</Typography>
              <Typography variant="body2" sx={{ opacity: 0.8, mt: 1 }}>
                Checking IP geolocation for security compliance
              </Typography>
            </Box>
          )}
          
          {locationCheck.result && locationCheck.result.is_indian && (
            <Box>
              <CheckCircle sx={{ fontSize: 60, color: "#4caf50", mb: 2 }} />
              <Typography variant="h6" gutterBottom>
                ✅ Location Verified
              </Typography>
              <Alert 
                severity="success" 
                sx={{ 
                  mt: 2, 
                  backgroundColor: "rgba(76, 175, 80, 0.1)",
                  color: "white",
                  "& .MuiAlert-icon": { color: "white" }
                }}
              >
                User verified from {locationCheck.result.country}
                {locationCheck.result.city && `, ${locationCheck.result.city}`}
              </Alert>
              <Typography variant="body2" sx={{ mt: 2, opacity: 0.9 }}>
                Redirecting to KYC process...
              </Typography>
            </Box>
          )}
          
          {locationCheck.result && !locationCheck.result.is_indian && (
            <Box>
              <Error sx={{ fontSize: 60, color: "#f44336", mb: 2 }} />
              <Typography variant="h6" gutterBottom>
                ❌ Access Restricted
              </Typography>
              <Alert 
                severity="error" 
                sx={{ 
                  mt: 2, 
                  backgroundColor: "rgba(244, 67, 54, 0.1)",
                  color: "white",
                  "& .MuiAlert-icon": { color: "white" }
                }}
              >
                User is from outside India ({locationCheck.result.country || 'Unknown'})
              </Alert>
              <Typography variant="body2" sx={{ mt: 2, opacity: 0.9 }}>
                KYC services are only available for users within India
              </Typography>
            </Box>
          )}
          
          {locationCheck.error && (
            <Box>
              <Error sx={{ fontSize: 60, color: "#ff9800", mb: 2 }} />
              <Typography variant="h6" gutterBottom>
                ⚠️ Verification Failed
              </Typography>
              <Alert 
                severity="warning" 
                sx={{ 
                  mt: 2, 
                  backgroundColor: "rgba(255, 152, 0, 0.1)",
                  color: "white",
                  "& .MuiAlert-icon": { color: "white" }
                }}
              >
                Unable to verify location: {locationCheck.error}
              </Alert>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <Button 
            onClick={() => setLocationDialog(false)} 
            variant="outlined" 
            sx={{ 
              color: "white", 
              borderColor: "white",
              "&:hover": { borderColor: "rgba(255,255,255,0.7)", backgroundColor: "rgba(255,255,255,0.1)" }
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog> */}

      {/* Popup for DigiLocker */}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)", color: "white" }}>
          Sign In via DigiLocker
        </DialogTitle>
        <DialogContent dividers sx={{ p: 3 }}>
          {step === "input" && (
            <Box>
              <TextField
                fullWidth
                label="Enter Aadhaar Number"
                value={aadhaarNumber}
                onChange={(e) => setAadhaarNumber(e.target.value)}
                inputProps={{ maxLength: 12 }}
                sx={{ mb: 2 }}
              />
              <Button
                fullWidth
                variant="contained"
                onClick={() => handleVerify(customerSession)}
                disabled={aadhaarNumber.length !== 12}
                sx={{ background: "#1976d2" }}
              >
                Verify
              </Button>
            </Box>
          )}

          {step === "processing" && (
            <Box>
              <Typography>Processing DigiLocker callback...</Typography>
              <Typography variant="body2" color="text.secondary">
                Exchanging authorization code for access token...
              </Typography>
            </Box>
          )}

          {step === "callback" && (
            <Box>
              <Typography>Fetching documents from DigiLocker...</Typography>
              <Typography variant="body2" color="text.secondary">
                Retrieving Aadhaar and PAN documents...
              </Typography>
            </Box>
          )}

          {step === "complete" && callbackResult && (
            <Box>
              <Typography variant="h6" color="success.main" gutterBottom>
                ✅ Details Fetched Successfully!
              </Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Aadhaar Number: {callbackResult.aadhaar_number || 'N/A'}
              </Typography>
              {callbackResult.aadhaar_photo_url && (
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Photo: Available
                </Typography>
              )}
              {callbackResult.pan_number && (
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  PAN: {callbackResult.pan_number}
                </Typography>
              )}
              <Typography variant="body2" color="text.secondary" mt={2}>
                All documents have been verified and stored successfully.
              </Typography>
            </Box>
          )}

          {step === "digilocker" && !accessToken && (
            <DialogActions>
              <Button onClick={handleClose} variant="outlined">
                Cancel
              </Button>
            </DialogActions>
          )}

          {step === "complete" && (
            <DialogActions>
              <Button onClick={handleClose} variant="outlined">
                Cancel
              </Button>
              <Button
                onClick={handleAuthorize}
                variant="contained"
                sx={{ background: "#1976d2" }}
                disabled={!(callbackResult && callbackResult.aadhaar_is_valid === "yes")}
              >
                Continue
              </Button>
            </DialogActions>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DigiLockerCard;
